export const siteInfo = {
  name: "网报吃瓜",
  slogan: "打开就是吃瓜事件库",
  description:
    "把热门专题按合集、盘点和列表放在一起，一个瓜从发生、发酵到后续整理成一条串，看完不用再去各平台零散拼时间线。",
  email: "hi@wangbaochigua.com",
  workingHours: "每日 09:00 - 23:00 整理更新",
  principles: [
    {
      icon: "ri-file-list-3-line",
      title: "只做事件串，不做碎片",
      desc: "同一个话题的节点收在同一条记录里，读者从上往下读一遍就能掌握完整过程。",
    },
    {
      icon: "ri-scales-3-line",
      title: "标注信源，不替代判断",
      desc: "对尚未有明确回应的内容标注为讨论中，说明信息来源范围，把结论留给读者。",
    },
    {
      icon: "ri-refresh-line",
      title: "持续追加，不另开新帖",
      desc: "出现新节点时在原事件串上追加记录，让更新保持连续，避免信息被切碎。",
    },
    {
      icon: "ri-shield-check-line",
      title: "不收传闻作结论",
      desc: "仅存在于单一信源的猜测不会作为正式节点收录，避免把不确定当成事实。",
    },
  ],
  milestones: [
    { year: "2023", title: "从一条时间线开始", desc: "最初只是个人整理的一个话题记录表，用来给自己追事件用。" },
    { year: "2024", title: "形成事件串规范", desc: "确立「发生—发酵—回应—后续」四段结构，并开始标注信源范围。" },
    { year: "2025", title: "分类体系上线", desc: "按娱乐、影视、音乐、综艺、网红与品牌六个方向整理出稳定分类。" },
    { year: "2026", title: "事件库开放浏览", desc: "把整理多年的记录整合成公开事件库，支持按分类与热度浏览。" },
  ],
  stats: [
    { value: "1,240+", label: "已整理事件串" },
    { value: "6", label: "内容分类方向" },
    { value: "3,800+", label: "累计记录节点" },
    { value: "每日", label: "更新整理节奏" },
  ],
};